<template>
  <div id="pageTable">
    
    <v-container grid-list-xl fluid paddingZero>
      <v-layout wrap class="custom-mb">
        <v-flex xs12 ma-0 pa-0>
          <v-card color="orange">
            <div class="profiletop">
              <v-card-text class="px-0">
                <v-avatar class="mx-auto d-block" size="220"> <img alt="Profile Image" title="Profile Image" :src="src_display" :style="{ width: defaultProfilePicWidth }"/>
                </v-avatar>
                <v-card-text class="text-xs-center profileTitle">
                  <h4>{{utils.getTitleCase(displayForm.first_name)}} {{utils.getTitleCase(displayForm.last_name)}}</h4>
                  <p class="card-description "> {{!displayForm.company_state && !displayForm.company_city ? notProvidedStr : ''}}
                    {{displayForm.company_city ? displayForm.company_city+',':''}} {{displayForm.company_state ? displayForm.company_state : ''}} 
                  </p>
                </v-card-text>
              </v-card-text>
            </div>
          </v-card>
        </v-flex>
        <template>
          <v-flex xs12 md6  ma-0 pa-0>
            <v-card color="transparent" class="vcard-position">
              <div class="custompadding20">
                <v-card-text>
                  <v-layout wrap>

                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc">
                        <v-icon>business_center</v-icon>
                        <h1>Business Name:</h1>
                        <p>{{displayForm.company_name}}</p>
                      </div>
                    </v-flex>
                    <!--<v-flex xs12 md6 ma-0 pa-0 v-if="!userStore.user.isImr">
                      <div class="profileDesc"> <i class="fas fa-road"></i>
                        <h1>MC Number:</h1>
                        <p>{{displayForm.mc_number}} </p>
                      </div>
                    </v-flex>-->
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="far fa-calendar-alt"></i>
                        <h1>Since:</h1>
                        <p>{{displayForm.since}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-globe"></i>
                        <h1>Website:</h1>
                        <p><a target="_blank" :href="displayForm.website" >{{displayForm.website}}</a></p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-map-marker-alt"></i>
                        <h1>Business Address:</h1>
                        <p> {{displayForm.company_address}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-globe"></i>
                        <h1>Social:</h1>
                        <template v-if="displayForm.linkedin_url == '' && displayForm.twitter_url == '' && displayForm.facebook_url == ''">
                            {{notProvidedStr}}    
                        </template>
                        <template v-else>
                            <p> 
                                <a v-if="displayForm.linkedin_url!=''" :href="displayForm.linkedin_url" target="_blank"><i class="fab fa-linkedin"></i></a> 
                                <a v-if="displayForm.twitter_url!=''" :href="displayForm.twitter_url" target="_blank"><i class="fab fa-twitter-square"></i></a> 
                                <a v-if="displayForm.facebook_url!=''" :href="displayForm.facebook_url" target="_blank"><i class="fab fa-facebook-square"></i></a> 
                            </p>
                        </template>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc">
                        <v-icon>business_center</v-icon>
                        <h1>Business Description:</h1>
                        <p>{{displayForm.company_desc}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
            <v-card>
              <div class="custompadding20 ">
                <v-card-text>
                  <v-layout wrap>
                    <!--<v-flex xs12 ma-0 pa-0 v-if="!userStore.user.isImr">
                      <div class="profileDesc">
                        <v-icon>local_shipping</v-icon>
                        <h1>Equipment Type:</h1>
                        <p>{{displayForm.equipment_type}}</p>
                      </div>
                    </v-flex>-->
                    <v-flex xs12 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-star"></i>
                        <h1>Hobbies:</h1>
                        <p>{{displayForm.hobbies}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
          <v-flex  xs12 md6 ma-0 pa-0>
            <div style="height:100%;min-height:400px;" id="profileMap"></div>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import services from "../services/HttpService";
import breadcrumbs from "./widgets/Breadcrumb";
import GoogleAds from "@/pages/widgets/GoogleAds";
import axios from "axios";
import config from "../config";
import utils from "../util";

export default {
    data: () => ({
        notProvidedStr:config.notProvidedStr,
        hidden_company_address: '',
        src_display: '',
        defaultProfilePicWidth:"inherit",
        displayForm: {
            mc_number: '',
            company_name: '',
            since: '',
            website: '',
            company_address: '',
            company_desc: '',
            equipment_type: '',
            hobbies: '',
            first_name: '',
            last_name: '',
            company_country: '',
            company_state: '',
            company_city: '',
            company_latitude: '',
            company_longitude: '',
            company_zip_code: '',
            linkedin_url: '',
            twitter_url:'',
            facebook_url:''
        },
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                disabled: true
            },
            {
                name: 'AutoLoader',
                disabled: true
            }
        ]
    }),
    components: {
        breadcrumbs,
        GoogleAds
    },
    mounted() {
        const self = this;
    },
    created() {
        const self = this,
            wApp = window.getApp;
        self.utils = utils;
        wApp.$emit("showLoader", {
          show: true
        });
        axios.all([
          services.post("users/userListById", {
              uuid: self.$route.query.user_id
          }, {
              'Authorization': 'Bearer ' + this.$store.state.user.token
          })
      ])
      .then(axios.spread(function (users) {
          self.displayForm = Object.assign({},users.data.data.User);
          self.displayForm.first_name = users.data.data.User.UserContacts.first_name;
          self.displayForm.last_name = users.data.data.User.UserContacts.last_name;

          if(users.data.data.User.UserContacts.image_path != ''){
              self.src_display = config.profileUrl + users.data.data.User.UserContacts.image_path;
          }else{
              self.src_display = config.defaultProfilePicPath;
              self.defaultProfilePicWidth = config.defaultProfilePicWidth+"px";
          }                
          self.getMap();
          wApp.$emit("showLoader", {
              show: false
          });

      }))
      .catch(function (err) {
          wApp.$emit("showLoader", {
              show: false
          });
          self._showToast(err.message, "red");
      });

    },
    methods: {
        getMap() {
            const self = this;
            // The location of Uluru
            var uluru = new google.maps.LatLng(self.displayForm.company_latitude, self.displayForm.company_longitude);
            // The map, centered at Uluru
            var map = new google.maps.Map(
                document.getElementById('profileMap'), {
                    zoom: 5,
                    center: uluru
                });
            var contentString = '<div id="content" class="MarkerLabelFontCls">' + self.displayForm.company_address + '</div>';
            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            // The marker, positioned at Uluru
            var marker = new google.maps.Marker({
                position: uluru,
                map: map,
                icon: '/static/icon/map-marker.png',
            });
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
    }
};
</script>
<style>
a.title-link-text {
    text-decoration: none !important;
    color:#ffffff !important;
}
.gm-style .gm-style-iw{
    color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/user-profile.vue